import { render, staticRenderFns } from "./CustomCarousel3.vue?vue&type=template&id=03cca260&scoped=true"
import script from "./CustomCarousel3.vue?vue&type=script&lang=js"
export * from "./CustomCarousel3.vue?vue&type=script&lang=js"
import style0 from "./CustomCarousel3.vue?vue&type=style&index=0&id=03cca260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cca260",
  null
  
)

export default component.exports